export default "__VITE_ASSET__DQ1t4nhv__"